import { PropsWithChildren } from 'react';

import { cn, Input, Switch, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui';
import { useFeatures } from '@/context/FeatureContext';

export const FeatureFlagTab = (props: PropsWithChildren<{ tab?: string }>) => {
  const features = useFeatures();
  const filteredFeatures = Object.values(features.all()).filter(feature => !props.tab || feature.tab === props.tab);

  return (
    <TooltipProvider>
      <div className="divide-y divide-line">
        {filteredFeatures.map(feature => {
          if (feature.hidden) {
            return null;
          }
          // Wrapping the switch in a label lets the whole row toggle it.
          const Row = typeof feature.value === 'boolean' ? 'label' : 'div';
          return (
            <Tooltip key={feature.name}>
              <TooltipTrigger asChild>
                <Row
                  className={cn(
                    'flex min-h-12 items-center gap-3 px-4 py-2 text-sm hover:bg-canvas',
                    typeof feature.value === 'boolean' && 'cursor-pointer',
                  )}
                >
                  <span className="min-w-0 flex-1">{feature.description}</span>
                  {typeof feature.value === 'boolean' ? (
                    <Switch
                      checked={feature.value}
                      aria-label={feature.description}
                      onCheckedChange={checked => features.set(feature.name, checked)}
                    />
                  ) : typeof feature.value === 'string' ? (
                    <Input
                      className="w-40 shrink-0"
                      aria-label={feature.description}
                      value={feature.value}
                      onChange={event => features.set(feature.name, event.target.value as any)}
                    />
                  ) : (
                    `Unknown value type: ${typeof feature.value}`
                  )}
                </Row>
              </TooltipTrigger>
              {!!feature.tooltip && <TooltipContent side="left">{feature.tooltip}</TooltipContent>}
            </Tooltip>
          );
        })}
        {props.children}
      </div>
    </TooltipProvider>
  );
};
